import { Toro } from '../common/enumerations';
import WaterDayMode = Toro.WaterDayMode;
import { ProgramExtendedInfo } from './program-extended-info';
import { ProgramMonthlyAdjustmentModel } from './program-monthly-adjustment.model';

export class ToroProgram {
    static waterDayStrings = ['Week Days', 'Odd Days', 'Even Days', 'Interval Days'];

    private _extendedInfo: ProgramExtendedInfo;

    constructor(json: object = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
            this.IsGrowInDaysRemaining = this.GrowInDaysRemaining > 0;
            this.SensorAdjustEnabled = this.ExtendedInfo.SensorAdjustEnabled;
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }

    // TODO: Complete the model

    public ProgramNumber = 0;
    public Name: string;
    public Description: string;
    public IsActive = false;
    public IsEnabled = false;
    public IsDisplayed = false;

    //TODO LXC
    public IsNonIrrigationProgram = false;

    public WaterDayMode: WaterDayMode = WaterDayMode.weekDays;
    public ActiveDays: boolean[];
    public MonthlyAdjustment: ProgramMonthlyAdjustmentModel;
    public WaterDays: number;
    public UseRestrictedDays: boolean;
    public RestrictedDays;
    public SkipDaysIntervalExclusion;
    public GrowInDaysRemaining: number;
    public IsGrowInDaysRemaining: boolean;
    public IntervalCurrentDay: number;
    public ActivatePerMonthWaterBudget: boolean;
    public PercentAdjust: number;
    public AutoAdjustment: boolean;
    public SensorAdjustEnabled: boolean;

    get ExtendedInfo(): ProgramExtendedInfo { return this._extendedInfo; }
    set ExtendedInfo(value: ProgramExtendedInfo) { this._extendedInfo = new ProgramExtendedInfo(value); }


    // public ProgramStatus = ProgramStatus;
    // public WaterDayMode = WaterDayMode;
    // IsForced = false;
    // Status: ProgramStatus = ProgramStatus.unknown;
    // NextScheduledStartTime: Date;
    // NextScheduledDurationInMinutes: number;
    // NextScheduledScheduleIndex: number;
    // StartTimes: Date[];
    // ExcludedDays: boolean[];
    // StationRunTimesInSeconds: number[];
    // WaterDayMode: WaterDayMode = WaterDayMode.weekDays;
    // WaterIntervalPeriod = 1;
}
